export enum enumPaymentMethod {
    STRIPE_ADVANCE = 'STRP_ADV',
    STRIPE_TRANSFER = 'STRP_TRANS',
    SCALAPAY_TRANSFER = 'SCLP_TRANS',
    BANK_TRANSFER_ADV = 'BANK_TRANS_ADV',
    BANK_TRANSFER_PAYOFF = 'BANK_TRANSFER_PAYOFF',
    CASH_ADV = 'CASH_ADV',
    CASH_PAYOFF = 'CASH_PAYOFF',
  }